import React, { Component } from "react";
import "./DeleteAccount.css";
import { FaCheck } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import Colors from "../../constants/Colors";
import firebase from "../../firebase/firebase";
import ClipLoader from "react-spinners/ClipLoader";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

require("firebase/functions");

interface IState {
  loading: boolean;
  status?: "success" | "error";
}

type Props = {
  oobCode: string;
};

export default class DeleteAccount extends Component<Props> {
  state: Readonly<IState> = {
    loading: true,
  };

  componentDidMount() {
    let that = this;

    if (!this.props.oobCode) {
      this.setState({
        loading: true,
      });
    } else {
      let deleteAccount = firebase.functions().httpsCallable("deleteAccount");

      deleteAccount({ token: this.props.oobCode })
        .then((result) => {
          if (result.data === true) {
            this.setState({
              loading: false,
              status: "success",
            });
          } else {
            this.setState({
              loading: false,
              status: "error",
            });
          }
        })
        .catch((e) => {
          this.setState({
            loading: false,
            status: "error",
          });
        });
    }
  }

  renderContent() {
    if (this.state.status === "success") {
      return <SuccessMessage />;
    } else {
      return <ErrorMessage />;
    }
  }

  render() {
    return (
      <div className={"mainContainer"}>
        {!this.state.loading && this.renderContent()}
        <ClipLoader
          size={80}
          color={Colors.mainColor}
          loading={this.state.loading}
        />
      </div>
    );
  }
}

function SuccessMessage() {
  const { t } = useTranslation();

  return (
    <div className={"innerContent"}>
      <div className={"iconContainer backgroundGreenColor"}>
        <FaCheck color={Colors.white} size={30} />
      </div>

      <div className={"messageContainer"}>
        <h2 style={{ fontWeight: 400 }}>{t("auth.deleteSuccessful")}</h2>
      </div>
    </div>
  );
}

function ErrorMessage() {
  const { t } = useTranslation();

  return (
    <div className={"innerContent"}>
      <div className={"iconContainer backgroundMainColor"}>
        <IoIosClose color={Colors.white} size={90} />
      </div>

      <div className={"messageContainer"}>
        <h2 style={{ fontWeight: 400 }}>{t("auth.deleteError")}</h2>
        <h3>{t("auth.deleteErrorCause")}</h3>
      </div>
    </div>
  );
}
